import { Injectable, inject } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, filter, first, switchMap } from 'rxjs/operators';
import { IUserSegmentationTagContext, IUserSegmentationTagDto, UserSegmentationTag } from 'src/app/contracts/api.types';
import { Api } from 'src/app/core/common/api';
import { Auth } from 'src/app/core/common/auth';

@Injectable({ providedIn: 'root' })
export class UserTagsData {
  private api = inject(Api);
  private auth = inject(Auth);

  /**
   * Fire-and-forget: report a OneSignal user-segmentation signal to the backend, which owns the concrete tag/event
   * names + values (so they can be renamed server-side without a client release). Only emits when authenticated —
   * segmentation tags are keyed by the user's identity, and this also avoids a 401 (and any auth-interceptor
   * redirect) for guests. Never blocks the UI: no loading spinner, errors swallowed.
   */
  track(tag: UserSegmentationTag, context?: IUserSegmentationTagContext): void {
    const payload: IUserSegmentationTagDto = { tag, ...context };
    this.auth.isAuthenticated$
      .pipe(
        first(),
        filter(isAuthenticated => isAuthenticated), // identity-keyed tags — skip guests (also avoids a 401 / interceptor redirect)
        switchMap(() => this.api.post('usertags/track', payload, { handleError: false, handleLoading: false })),
        catchError(() => EMPTY)
      )
      .subscribe();
  }
}
